import _ from 'underscore';

export function updateAdExtensionAssociationSourcePropertyForFilter({ entitySchema }) {
  const toExtended = {
    SourceType: {
      sortable: true,
      filterable: true,
      name: 'SourceType',
      originalProperty: 'SourceType',
      property: 'SourceType',
      type: 'string',
      enumType: 'AdExtensionAssociationSourceType',
      enum: [
        'UserCreated',
        'SystemGenerated',
      ],
      enumValueMap: {
        "Enum.AdExtensionAssociationSourceType'UserCreated'": 'UserCreated',
        "Enum.AdExtensionAssociationSourceType'SystemGenerated'": 'SystemGenerated',
      },
      chooseType: 'checkbox',
      alias: {
        legacy: 'SourceType',
      },
    },
  };

  _.extend(entitySchema.properties, toExtended);
}

